<template lang="pug">
.post-author(
  :title="authorName"
)
  user-avatar.post-author__avatar(
    :class="{'--right': avatarRight}"
    size="xs"
    :user="author"
  )

  .post-author__posted-by(
    v-if="!hideName"
  )
    span.post-author__posted-by-prefix(
      v-if="!hideBy"
    ) by 
    span.author-name {{ authorName }}
</template>

<script>
import UserAvatar from '@/components/user-avatar'

export default {
  name: 'post-author',
  components: {
    UserAvatar,
  },
  props: {
    author: {
      type: Object,
    },
    hideBy: {
      type: Boolean,
      default: false,
    },
    hideName: {
      type: Boolean,
      default: false,
    },
    avatarRight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    authorName() {
      return this.author.username
    },
  },
}
</script>

<style lang="sass">
.post-author
  display: flex
  align-items: center

.post-author__posted-by
  display: inline-block
  white-space: nowrap
  padding: 0.5rem

.post-author__avatar 
  &.--right
    order: 2
</style>
